import { escapeHtml } from "../site-search/search-escaping.js";

export const lijuPath = "/user/liju/";
export const lijuItemsPath = "/user/liju/items/";
export const savedLijuField = "uuid";

export function savedLijuControl(properties: {
  uuid: string;
  label: string;
  held?: boolean;
}): string {
  const uuid = escapeHtml(properties.uuid);
  const label = escapeHtml(properties.label);
  const held = properties.held ?? false;

  return `<div class="cb-save-word cb-save-liju">
<form class="cb-save-word-form cb-save-liju-form" method="post" action="${lijuPath}">
<button class="cb-save-word-action cb-save-liju-action" type="submit" name="${savedLijuField}" value="${uuid}" aria-label="${held ? "Saved" : "Save"} ${label}${held ? ", press to remove" : ""}"${held ? ' data-cb-saved="yes"' : ""}><span class="cb-save-word-label cb-save-liju-label">${held ? "Saved" : "Save"}</span></button>
</form>
<p class="cb-save-word-offer cb-save-liju-offer" hidden><a class="cb-sign-in" href="/user/sign-in/">Sign in to save sentences</a></p>
</div>`;
}
